module.exports = __webpack_public_path__ + "static/media/default-pos.3b5bb6d2.svg";